'use client'

import Image from 'next/image'
import { useTranslations } from 'next-intl'
import { FoodCarousel, type FoodPhoto } from './FoodCarousel'
import { SectionHeader } from './SectionHeader'

type Props = {
  text: string
  photoUrl?: string
  /** Fotos de los platillos del menú para el carrusel automático. */
  foodPhotos?: FoodPhoto[]
}

export function AboutSection({ text, photoUrl, foodPhotos = [] }: Props) {
  const t = useTranslations('public.microsite')
  // Foto del split: la del operador si la subió, si no la primera del menú.
  const splitPhoto = photoUrl ?? foodPhotos[0]?.url

  return (
    <section className="py-16 sm:py-24 px-5 sm:px-8" style={{ background: 'var(--ms-surface-2)' }}>
      <div className="max-w-6xl mx-auto">
        <div className={`grid gap-10 sm:gap-14 items-center ${splitPhoto ? 'md:grid-cols-2' : ''}`}>
          <div>
            <SectionHeader number="02" kicker={t('aboutKicker')} title={t('aboutUs')} />
            <p
              className="mt-6 whitespace-pre-line leading-[1.75] text-[16px] max-w-prose"
              style={{ color: 'var(--ms-text-soft)' }}
            >
              {text}
            </p>
          </div>
          {splitPhoto && (
            <div
              className="relative w-full overflow-hidden"
              style={{
                aspectRatio: '4 / 5',
                borderRadius: 'calc(var(--ms-radius) * 1.3)',
                boxShadow: '0 30px 60px -30px rgba(26,18,8,0.3)',
              }}
            >
              <Image src={splitPhoto} alt="" fill sizes="(max-width: 768px) 100vw, 50vw" className="object-cover" />
            </div>
          )}
        </div>

        <FoodCarousel photos={foodPhotos} />
      </div>
    </section>
  )
}
